import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"
import { getModelResourcePath } from "@/helper/models/model-helper"

export class LockRepository {
  public async getLocks() {
    return new HTTPRequestBuilder(HTTPMethods.GET, "planning/instructions/locks/")
      .setExpectedStatusCode(200)
      .build()
      .execute()
  }

  public async lock(className: string, modelId: string) {
    const path = `${getModelResourcePath(className)}/${modelId}/lock/`

    return new HTTPRequestBuilder(HTTPMethods.POST, path)
      .setExpectedStatusCode([201, 423])
      .build()
      .execute()
  }

  public async release(className: string, modelId: string) {
    const path = `${getModelResourcePath(className)}/${modelId}/lock/`

    return new HTTPRequestBuilder(HTTPMethods.DELETE, path)
      .setExpectedStatusCode(204)
      .build()
      .execute()
  }
}
